import { usePlanOnlyUseCreditPayment as useOnlyUseCreditPayment } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/only-use-credit-payment/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanOnlyUseCreditPayment = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { onlyUseCreditPayment } = viewModel;

	return useOnlyUseCreditPayment({ onSetViewModel, onlyUseCreditPayment });
};
